import React from 'react';
import { Navigate } from 'react-router-dom';

const RedirectToEvents = () => <Navigate to="events" />;

export default RedirectToEvents;
